module.exports = __webpack_public_path__ + "static/media/icon-expand-open.f49f5f23.svg";